import type { BreadCrumbsType } from '~~/shared/api/rurality/v3/search/cottages/schema'
import type { MenuBreadcrumbItems } from '~~/modules/menu/entities/MenuBreadcrumbItems'

const decoratorCottageListToMenuBreadcrumb = (
  breadCrumbs: BreadCrumbsType,
): MenuBreadcrumbItems => {
  const breadcrumbMenu: MenuBreadcrumbItems = []

  breadcrumbMenu.push({
    href: routes().cottageDefinedList(),
    name: t('menu.breadcrumb.cottages'),
  })

  if (breadCrumbs.region?.name && breadCrumbs.region?.slug) {
    breadcrumbMenu.push({
      href: routes().cottageDefinedList({ slug: breadCrumbs.region.slug }),
      name: breadCrumbs.region.name,
    })
  }

  if (
    breadCrumbs.province?.name &&
    breadCrumbs.province?.slug &&
    breadCrumbs.region?.slug !== breadCrumbs.province.slug
  ) {
    breadcrumbMenu.push({
      href: routes().cottageDefinedList({ slug: breadCrumbs.province.slug }),
      name: breadCrumbs.province.name,
    })
  }

  if (breadCrumbs.village?.name && breadCrumbs.village?.slug) {
    breadcrumbMenu.push({
      href: routes().cottageDefinedList({ slug: breadCrumbs.village.slug }),
      name: breadCrumbs.village.name,
    })
  }

  if (breadCrumbs.zone?.name && breadCrumbs.zone?.slug) {
    breadcrumbMenu.push({
      href: routes().cottageDefinedList({ slug: breadCrumbs.zone.slug }),
      name: breadCrumbs.zone.name,
    })
  }

  if (breadCrumbs.corner?.name && breadCrumbs.corner?.slug) {
    const villageSlug = breadCrumbs.village?.slug || breadCrumbs.province?.slug
    if (villageSlug) {
      breadcrumbMenu.push({
        href: `/casas-rurales/${villageSlug}/${breadCrumbs.corner.slug}`,
        name: breadCrumbs.corner.name,
      })
    }
  }

  return breadcrumbMenu
}

export default decoratorCottageListToMenuBreadcrumb
